export const IconChevron = ({ direction }: { direction: "up" | "down" }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{
      transform: direction === "up" ? "rotate(180deg)" : "rotate(0deg)",
      transition: "transform 0.3s",
    }}
  >
    <polyline points="6 9 12 15 18 9"></polyline>
  </svg>
);
